module.exports = __webpack_public_path__ + "img/app-development-cost.15de0ce3.png";